module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row vertical-align-center"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "row vertical-align-center"
  }, [_c('div', {
    staticClass: "dataTables_length col-sm-4",
    attrs: {
      "id": "example1_length"
    }
  }, [_c('label', [_vm._v("Show\n            "), _c('select', {
    staticClass: "form-control input-sm",
    attrs: {
      "name": "example1_length",
      "aria-controls": "example1"
    },
    on: {
      "change": _vm.showSizeChange
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "25"
    }
  }, [_vm._v("25")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("100")])]), _vm._v(" entries\n          ")])]), _vm._v(" "), (_vm.selectedTestimonies && _vm.selectedTestimonies.length) ? _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-primary dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n            Mark " + _vm._s(_vm.selectedTestimonies.length) + " selected as  "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.updateTestimoniesStatus('READ')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-envelope-open"
  }), _vm._v("Read")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.updateTestimoniesStatus('UNREAD')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-envelope"
  }), _vm._v("Unread")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.updateTestimoniesStatus('PROCESSING')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-balance-scale"
  }), _vm._v("Processing\n                ...")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.updateTestimoniesStatus('PROCESSED')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-check"
  }), _vm._v("Processed")])]), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.clearSelection()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-ban"
  }), _vm._v("Clear selection")])])])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default col-sm-offset-1 col-sm-2 filter-btn",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#filters",
      "aria-expanded": "false",
      "aria-controls": "collapseExample"
    }
  }, [_vm._v("\n          Filters\n        ")])])]), _vm._v(" "), (_vm.searchEnabled) ? _c('div', {
    staticClass: "col-sm-6 search-table"
  }, [_c('div', {
    staticClass: "dataTables_filter",
    attrs: {
      "id": "example1_filter"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "search",
      "placeholder": "Syria",
      "aria-controls": "example1"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "change": _vm.searchChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-flat btn-primary search-btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.search
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row filters-row"
  }, [_c('div', {
    staticClass: "col-sm-12 collapse filters",
    attrs: {
      "id": "filters"
    }
  }, [_c('div', {
    staticClass: "card card-body"
  }, [_c('form', {
    staticClass: "form-inline"
  }, [_c('label', [_vm._v("Get only testimonies created after")]), _vm._v(" "), _c('div', {
    staticClass: "form-control date-control"
  }, [_c('datepicker', {
    attrs: {
      "clear-button": true,
      "format": "MM/dd/yyyy"
    },
    model: {
      value: (_vm.startCreationDate),
      callback: function($$v) {
        _vm.startCreationDate = $$v
      },
      expression: "startCreationDate"
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v("and before")]), _vm._v(" "), _c('div', {
    staticClass: "form-control date-control"
  }, [_c('datepicker', {
    attrs: {
      "clear-button": true,
      "format": "MM/dd/yyyy"
    },
    model: {
      value: (_vm.endCreationDate),
      callback: function($$v) {
        _vm.endCreationDate = $$v
      },
      expression: "endCreationDate"
    }
  })], 1)]), _vm._v(" "), _c('form', {
    staticClass: "form-inline"
  }, [_c('label', [_vm._v("And attack occured after")]), _vm._v(" "), _c('div', {
    staticClass: "form-control date-control"
  }, [_c('datepicker', {
    attrs: {
      "clear-button": true,
      "format": "MM/dd/yyyy"
    },
    model: {
      value: (_vm.startAttackDate),
      callback: function($$v) {
        _vm.startAttackDate = $$v
      },
      expression: "startAttackDate"
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v("and before")]), _vm._v(" "), _c('div', {
    staticClass: "form-control date-control"
  }, [_c('datepicker', {
    attrs: {
      "clear-button": true,
      "format": "MM/dd/yyyy"
    },
    model: {
      value: (_vm.endAttackDate),
      callback: function($$v) {
        _vm.endAttackDate = $$v
      },
      expression: "endAttackDate"
    }
  })], 1)]), _vm._v(" "), _c('tags-search', {
    ref: "tags-search"
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    staticClass: "sorting_asc",
    class: {
      active: _vm.sortField === 'creationDate'
    },
    attrs: {
      "aria-label": "Creation date",
      "aria-sort": "ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('creationDate', 'true')
      }
    }
  }, [_vm._v("Creation Date")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "Purpose",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Purpose")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "Lastname",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Victim name")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "Minor",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Minor")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "Gender",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Gender")]), _vm._v(" "), _c('th', {
    staticClass: "sorting_asc",
    class: {
      active: _vm.sortField === 'actionPeriod.startDate'
    },
    attrs: {
      "aria-label": "Attack date",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('actionPeriod.startDate', 'true')
      }
    }
  }, [_vm._v("Attack date")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "Attack time",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Attack time\n            ")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "Place",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Place")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "Origin",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Origin")]), _vm._v(" "), _c('th', {
    staticClass: "sorting_asc",
    class: {
      active: _vm.sortField === 'similarNumbers'
    },
    attrs: {
      "aria-label": "Similar case",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('similarNumbers', 'true')
      }
    }
  }, [_vm._v("Similar")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "Tags",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Tags")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "Tags",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Code")])])]), _vm._v(" "), (_vm.testimonies.length === 0) ? _c('div', {
    staticClass: "no-data"
  }, [_vm._v("No data found")]) : _c('tbody', _vm._l((_vm.testimonies), function(testimony) {
    return _c('tr', {
      class: testimony.status === 'UNREAD' ? 'unread' : '',
      attrs: {
        "role": "row"
      },
      on: {
        "click": function($event) {
          return _vm.goTo(testimony)
        }
      }
    }, [_c('td', {
      staticClass: "text-center",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleSelection($event, testimony)
        }
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.selectedTestimonies.indexOf(testimony._id) !== -1
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(testimony.status === 'UNREAD') ? _c('i', {
      staticClass: "fa fa-envelope",
      attrs: {
        "title": "Unread"
      }
    }) : (testimony.status === 'PROCESSING') ? _c('i', {
      staticClass: "fa fa-balance-scale",
      attrs: {
        "title": "Processing ..."
      }
    }) : (testimony.status === 'PROCESSED') ? _c('i', {
      staticClass: "fa fa-check",
      attrs: {
        "title": "Processed"
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(_vm._f("prettyDateTime")(testimony.creationDate)))]), _vm._v(" "), _c('td', [(testimony.purpose) ? _c('span', [_vm._v(_vm._s(testimony.purpose))]) : _vm._e()]), _vm._v(" "), _c('td', [(testimony.victimIdentity) ? _c('span', [_vm._v(_vm._s(testimony.victimIdentity.name))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(testimony.victimIdentity && testimony.victimIdentity.minor ? 'Yes' : 'No'))]), _vm._v(" "), _c('td', [(testimony.victimIdentity) ? _c('span', [_vm._v(_vm._s(testimony.victimIdentity.gender))]) : _vm._e()]), _vm._v(" "), _c('td', [(testimony.actionPeriod) ? _c('span', [_vm._v("\n                " + _vm._s(_vm._f("prettyDate")(testimony.actionPeriod.startDate)) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('td', [(testimony.actionPeriod) ? _c('span', [_vm._v("\n                " + _vm._s(_vm._f("prettyTime")(testimony.actionPeriod.startTime)) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('td', [(testimony.actionDetail && testimony.actionDetail.actionLocation) ? _c('span', [_vm._v("\n                " + _vm._s(testimony.actionDetail.actionLocation.zone) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(testimony.originInfo ? testimony.originInfo.origin : 'UNKNOWN') + "\n            ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(testimony.similarNumbers))]), _vm._v(" "), _c('td', _vm._l((_vm.tagsByTestimony[testimony._id]), function(tag) {
      return _c('span', {
        staticClass: "label label-default",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.searchByTag(tag)
          }
        }
      }, [_vm._v(_vm._s(tag))])
    }), 0), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(testimony.randomId) + "\n            ")])])
  }), 0)])])]), _vm._v(" "), (_vm.testimonies.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "align-infos col-sm-12"
  }, [_c('div', {
    staticClass: "dataTables_info",
    attrs: {
      "id": "example1_info",
      "role": "status",
      "aria-live": "polite"
    }
  }, [_vm._v("Showing\n        " + _vm._s(_vm.total - _vm.testimonies.length + 1 > _vm.page * _vm.size + 1 ? _vm.page * _vm.size + 1 : _vm.total - _vm.testimonies.length + 1) + "\n        to " + _vm._s(_vm.total > (_vm.page + 1) * _vm.size ? (_vm.page + 1) * _vm.size : _vm.total) + " of " + _vm._s(_vm.total) + " entries\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "table-pagination col-sm-12"
  }, [_c('paginate', {
    attrs: {
      "page-count": _vm.pageTotal,
      "page-range": 3,
      "margin-pages": 2,
      "click-handler": _vm.changePage,
      "prev-text": 'Prev',
      "force-page": _vm.page,
      "next-text": 'Next',
      "container-class": 'pagination',
      "page-class": 'page-item'
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16902fe0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/TestimoniesList.vue
// module id = 428
// module chunks = 1